import styled from 'styled-components';
import { mediaQuery } from '../../../utils/mediaQuery';

export const ComparatorContainer = styled.div`
  border-radius: 8px;
  border: 1px solid #e1dddd;
  margin-top: 20px;
  margin-bottom: 20px;
  background-color: white;

  ${mediaQuery.mobileOnly(`
    border-width: 0px;
  `)}
`;

//TABLE
export const TableContainerStyled = styled.div`
  overflow-x: auto;
  padding: 10px 0;
  width: inline-table;
`;

export const TableStyled = styled.table`
  border-collapse: separate;
  border-spacing: 0;
  width: max-content;

  & tr:first-child th {
    border-top: none !important;
    vertical-align: top;
  }

  ${mediaQuery.mobileOnly(`
    & thead, tbody {
      display: table-header-group;
    }  
  `)}
`;

export const TableHeader = styled.th`
  margin: 0;
  width: 196px;
  padding: 2px 6px;
  font-weight: normal;
`;

export const TableData = styled.td`
  margin: 0;
  border-top: 1px solid #e3e4e5;
  width: 196px;
  padding: 16px 10px;
  font-size: 14px;
  color: #595959;
  font-weight: normal;
  vertical-align: top;

  ${mediaQuery.tabletToUp(`
    font-size: 17px;
    padding: 16px 14px;
  `)}
`;

export const TableRow = styled.tr`
  & th:first-child,
  td:first-child {
    z-index: 1;
    margin-left: 0;
    min-width: 5px;
    position: absolute;
    width: auto;
    left: auto;
    top: auto;
    border-top-width: 0px;
    text-align: left;
    height: auto;
    padding: 5px;
    background-color: #ffffff;
  }

  & td:first-child {
    padding: 5px 4px 5px 10px;
    margin-top: -11px;
    height: auto;
    color: #333333;
    white-space: nowrap;
    font-size: 12px;
    font-weight: bold;
  }

  ${mediaQuery.tabletToUp(`   
    & th:first-child, td:first-child {
      margin: 0 0 0 2em !important;
      min-width: 80px;
      position: sticky;
      width: 6em;
      left: 0;
      top: auto;
      border-top-width: 1px;
      text-align: left;
      height: auto;
      padding: 5px;
      background-color: #ffffff;
    }

    & td:first-child {
      padding: 13px 4px 13px 10px;
      font-weight: bold;
      white-space: normal;
      font-size: 14px;
      line-height: 16px;
    }    
  `)}
`;
